import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ILogModel } from 'src/app/models/interfaces/ILogModel';

@Component({
  selector: 'app-log-dialog',
  templateUrl: './log-dialog.component.html',
  styleUrls: ['./log-dialog.component.css']
})
export class LogDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ILogModel[],
  ) { }

  ngOnInit(): void {
  }

}
